/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getConsumables } from 'app/entities/consumable/consumable.reducer';
import { getEntities as getImplants } from 'app/entities/implant/implant.reducer';
import { getEntities as getTemplatePrescriptions } from 'app/entities/template-prescription/template-prescription.reducer';
import { TemplateItemType } from 'app/shared/model/enumerations/template-item-type.model';
import { createEntity, getEntity, reset, updateEntity } from './template-medication.reducer';

export const TemplateMedicationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const consumables = useAppSelector(state => state.consumable.entities);
  const implants = useAppSelector(state => state.implant.entities);
  const templatePrescriptions = useAppSelector(state => state.templatePrescription.entities);
  const templateMedicationEntity = useAppSelector(state => state.templateMedication.entity);
  const loading = useAppSelector(state => state.templateMedication.loading);
  const updating = useAppSelector(state => state.templateMedication.updating);
  const updateSuccess = useAppSelector(state => state.templateMedication.updateSuccess);
  const templateItemTypeValues = Object.keys(TemplateItemType);

  const handleClose = () => {
    navigate(`/template-medication${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getConsumables({}));
    dispatch(getImplants({}));
    dispatch(getTemplatePrescriptions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.prescribedCount !== undefined && typeof values.prescribedCount !== 'number') {
      values.prescribedCount = Number(values.prescribedCount);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...templateMedicationEntity,
      ...values,
      consumable: consumables.find(it => it.id.toString() === values.consumable?.toString()),
      implant: implants.find(it => it.id.toString() === values.implant?.toString()),
      prescription: templatePrescriptions.find(it => it.id.toString() === values.prescription?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          templateItemType: 'CONSUMABLE',
          ...templateMedicationEntity,
          consumable: templateMedicationEntity?.consumable?.id,
          implant: templateMedicationEntity?.implant?.id,
          prescription: templateMedicationEntity?.prescription?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.templateMedication.home.createOrEditLabel" data-cy="TemplateMedicationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.templateMedication.home.createOrEditLabel">
              Create or edit a TemplateMedication
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="template-medication-id"
                  label={translate('tinyMedicRestApp.templateMedication.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.repetition')}
                id="template-medication-repetition"
                name="repetition"
                data-cy="repetition"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.active')}
                id="template-medication-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.cursor')}
                id="template-medication-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.lastUpdated')}
                id="template-medication-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.microSec')}
                id="template-medication-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.timestampEntry')}
                id="template-medication-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.prescribedCount')}
                id="template-medication-prescribedCount"
                name="prescribedCount"
                data-cy="prescribedCount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.indication')}
                id="template-medication-indication"
                name="indication"
                data-cy="indication"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.daysFrequency')}
                id="template-medication-daysFrequency"
                name="daysFrequency"
                data-cy="daysFrequency"
                type="text"
                validate={{
                  maxLength: { value: 250, message: translate('entity.validation.maxlength', { max: 250 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.endDate')}
                id="template-medication-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.dose')}
                id="template-medication-dose"
                name="dose"
                data-cy="dose"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.route')}
                id="template-medication-route"
                name="route"
                data-cy="route"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.templateItemType')}
                id="template-medication-templateItemType"
                name="templateItemType"
                data-cy="templateItemType"
                type="select"
              >
                {templateItemTypeValues.map(templateItemType => (
                  <option value={templateItemType} key={templateItemType}>
                    {translate(`tinyMedicRestApp.TemplateItemType.${templateItemType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.medicineName')}
                id="template-medication-medicineName"
                name="medicineName"
                data-cy="medicineName"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.doseInstructions')}
                id="template-medication-doseInstructions"
                name="doseInstructions"
                data-cy="doseInstructions"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateMedication.tmType')}
                id="template-medication-tmType"
                name="tmType"
                data-cy="tmType"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                id="template-medication-consumable"
                name="consumable"
                data-cy="consumable"
                label={translate('tinyMedicRestApp.templateMedication.consumable')}
                type="select"
              >
                <option value="" key="0" />
                {consumables
                  ? consumables.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="template-medication-implant"
                name="implant"
                data-cy="implant"
                label={translate('tinyMedicRestApp.templateMedication.implant')}
                type="select"
              >
                <option value="" key="0" />
                {implants
                  ? implants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="template-medication-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.templateMedication.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {templatePrescriptions
                  ? templatePrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/template-medication" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TemplateMedicationUpdate;
